import { reducer as formReducer } from 'redux-form';
import { prefixPlusIfNeeded } from '../utils/phone';

export const form = formReducer.normalize({
  login: {
    dialCode: (value, previousValue, allValues) =>
      value && prefixPlusIfNeeded(value),
  },
});



// WEBPACK FOOTER //
// ./app/reducers/reduxForm.js